import { SubscriptionPlan, SubscriptionPlanEnum, TrialPeriod } from '@vacationtracker/shared/types/company'
import { FeatureFlagEnum } from '@vacationtracker/shared/types/feature-flags'
import { StripePaymentStatus } from '@vacationtracker/shared/types/stripe'
import { CompleteTrialFeatureValue, COMPLETE_TRIAL_FEATURE_VALUES, SHOW_ME_EVERYTHING } from '@vacationtracker/shared/constants/complete-trial-request'

export const COMPLETE_TRIAL_REQUEST_WINDOW_DAYS = 30

const FEATURE_LABEL_KEYS: Record<CompleteTrialFeatureValue, string> = {
  [FeatureFlagEnum.multiLevelApproval]: 'completeTrialRequest.feature.multiLevelApproval',
  [FeatureFlagEnum.hours]: 'completeTrialRequest.feature.hourlyLeaveAccounting',
  [FeatureFlagEnum.accruals]: 'completeTrialRequest.feature.accruals',
  [FeatureFlagEnum.scheduledReports]: 'completeTrialRequest.feature.scheduledReports',
  [FeatureFlagEnum.toil]: 'completeTrialRequest.feature.toil',
  [FeatureFlagEnum.labels]: 'completeTrialRequest.feature.labels',
  [FeatureFlagEnum.syncSharedCalendars]: 'completeTrialRequest.feature.sharedCalendars',
  [FeatureFlagEnum.substituteApprovers]: 'completeTrialRequest.feature.substituteApprovers',
  [SHOW_ME_EVERYTHING]: 'completeTrialRequest.feature.showMeEverything',
}

export const COMPLETE_TRIAL_FEATURES = COMPLETE_TRIAL_FEATURE_VALUES.map((value) => ({ value, labelKey: FEATURE_LABEL_KEYS[value] }))

const BLOCKING_PAYMENT_STATUSES: StripePaymentStatus[] = ['past_due', 'unpaid', 'canceled', 'incomplete', 'incomplete_expired', 'paused']

interface IEligibilityParams {
  plan?: SubscriptionPlan
  trialPeriod?: TrialPeriod
  stripePaymentStatus?: StripePaymentStatus
  subscriptionCancelAtPeriodEnd?: boolean
}

/**
 * Three account states have to stay distinct: paying Core, Freemium and
 * mid-trial. "Currently paying" would drop Freemium, and "not Complete" would
 * let accounts inside their own trial through. Both are wrong.
 */
export function isEligibleForCompleteTrialRequest({ plan, trialPeriod, stripePaymentStatus, subscriptionCancelAtPeriodEnd }: IEligibilityParams): boolean {
  if (plan !== SubscriptionPlanEnum.core && plan !== SubscriptionPlanEnum.freemium) {
    return false
  }
  if (trialPeriod === 'in_trial' || trialPeriod === 'trial_will_end') {
    return false
  }
  if (stripePaymentStatus && BLOCKING_PAYMENT_STATUSES.includes(stripePaymentStatus)) {
    return false
  }
  return !subscriptionCancelAtPeriodEnd
}
